import { render } from "./RegistrationButtons.vue?vue&type=template&id=6d660094&scoped=true"
import script from "./RegistrationButtons.vue?vue&type=script&lang=js"
export * from "./RegistrationButtons.vue?vue&type=script&lang=js"

import "./RegistrationButtons.vue?vue&type=style&index=0&id=6d660094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d660094"]])

export default __exports__